import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["type"];
import { useEnrichableObjectTypes } from './EnrichableObjectTypeProvider';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const CompanyLabel = ({
  isPlural = false,
  isCapitalized = true
}) => {
  const {
    companyLabel,
    companyLabelPlural,
    companyLabelLowercase,
    companyLabelPluralLowercase
  } = useEnrichableObjectTypes();
  if (isCapitalized) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: isPlural ? companyLabelPlural : companyLabel
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isPlural ? companyLabelPluralLowercase : companyLabelLowercase
  });
};
export const ContactLabel = ({
  isPlural = false,
  isCapitalized = true
}) => {
  const {
    contactLabel,
    contactLabelPlural,
    contactLabelLowercase,
    contactLabelPluralLowercase
  } = useEnrichableObjectTypes();
  if (isCapitalized) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: isPlural ? contactLabelPlural : contactLabel
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isPlural ? contactLabelPluralLowercase : contactLabelLowercase
  });
};
export const ObjectTypeLabel = _ref => {
  let {
      type = 'company'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (type === 'contact') {
    return /*#__PURE__*/_jsx(ContactLabel, Object.assign({}, rest));
  }
  return /*#__PURE__*/_jsx(CompanyLabel, Object.assign({}, rest));
};